export const mandatoryEducation = ["YCMOU", "SSC", "10th/Matric", "NIOS"];